// import "../css/style.css";
import "../scss/styles.scss";
export default class Main {
  constructor() { 
    let bd = document.getElementsByTagName('html')[0];
    this.bd = bd;
   
    return false
  }
  render() {
    var swiper = new Swiper('.swiper-container', {
      slidesPerView: 1,
      spaceBetween: 10,
      // init: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        '@0.00': {
          slidesPerView: 1.1,
          spaceBetween: 10,
        },
        '@0.75': {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        '@1.00': {
          slidesPerView: 1.4,
          spaceBetween: 20,
        },
        '@1.50': {
          slidesPerView: 1.4,
          spaceBetween: 20,
        },
      }
    });
    var other = new Swiper('.js-other', {
      slidesPerView:1,
      spaceBetween: 30,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        '@0.00': {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        '@0.75': {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        '@1.00': {
          slidesPerView: 1.4,
          spaceBetween: 20,
        },
        '@1.50': {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
      }
    });
    this.ageCheck();
    
  }

  ageCheck(){
    let EntryPoint = window.location.href;
    if(this.isNullOrEmpty($.cookie('IM'))){
      if(window.location.href.indexOf('/age-check') === -1){
        window.location.replace("/age-check");
        return false
      }
    }
  }
  isNullOrEmpty(xValue) {
    if (typeof (xValue) == "boolean") {
      return false;
    } else {
      if ((xValue == null) || (xValue == undefined) || (xValue == "")) {
        return true;
      }
    }
    return false;
  };
}

